/**
 * Display-time clean-up for free text that arrives from ERP imports.
 *
 * Some ERP feeds URL-encode text fields ("12+High+Street" / "Unit%205") and
 * serialise empty values as the literal string "None". The data is stored
 * as received; these helpers tidy it for display only.
 */

const NULL_LIKE = new Set(['none', 'null', 'undefined', 'nan', 'n/a']);

/**
 * Returns '' for null-like values ("None", "null", blank) and decodes
 * URL-encoded text ("+" → space, "%20" → space) for everything else.
 *
 * @param value - Raw text from the API
 * @returns Display-safe text ('' when there is nothing to show)
 */
export function cleanErpText(value: string | null | undefined): string {
  if (value === null || value === undefined) return '';
  const trimmed = String(value).trim();
  if (!trimmed || NULL_LIKE.has(trimmed.toLowerCase())) return '';
  const plusDecoded = trimmed.replace(/\+/g, ' ');
  try {
    return decodeURIComponent(plusDecoded).replace(/\s+/g, ' ').trim();
  } catch {
    // Malformed escape sequence — show the "+"-decoded text as-is.
    return plusDecoded.replace(/\s+/g, ' ').trim();
  }
}
